"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var localization_1 = require("@scuf/localization");
var FilterPanelRender_1 = __importDefault(require("./FilterPanelRender"));
var Item_1 = __importDefault(require("./Item/Item"));
var Section_1 = __importDefault(require("./Section/Section"));
var ToggleItem_1 = __importDefault(require("./ToggleItem/ToggleItem"));
var translations_1 = __importDefault(require("./translations"));
/**
 * @child ./Section/Section.tsx
 * @child ./ToggleItem/ToggleItem.tsx
 * @child ./Item/Item.tsx
 */
var FilterPanel = /** @class */ (function (_super) {
    __extends(FilterPanel, _super);
    function FilterPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterPanel.prototype.render = function () {
        return React.createElement(localization_1.LocalizationProvider, { translations: translations_1.default },
            React.createElement(FilterPanelRender_1.default, __assign({}, this.props)));
    };
    FilterPanel.Section = Section_1.default;
    FilterPanel.Item = Item_1.default;
    FilterPanel.ToggleItem = ToggleItem_1.default;
    FilterPanel.defaultProps = {
        manualClose: false
    };
    return FilterPanel;
}(React.Component));
exports.default = FilterPanel;
//# sourceMappingURL=FilterPanel.js.map